{
  "fr": {
    "question_list": {
      "actions": {
        "cancel": "Annuler",
        "cancelOrder": "Annuler",
        "delete": "Supprimer",
        "deleteMultipleQuestionLists": "Supprimer...",
        "delete_cancel": "Annuler",
        "edit": "Modifier",
        "new": "Liste FAQ",
        "reorderQuestions": "Réorganiser les questions",
        "save": "Enregistrer",
        "saveOrder": "Sauvegarder",
        "submit": "Créer",
        "tickBoxesDeletion": "Sélectionnez les listes de FAQ que vous souhaitez supprimer."
      },
      "attributes": {
        "description": "Description",
        "name": "Nom",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Toutes les Unités",
        "descriptionOptional": "Description (optionnel)",
        "editFAQ": "Modifier Liste FAQ",
        "faq_all_projects": "FAQ tous les projets",
        "info": "Vous avez une question sur votre maison? Restez à l'écoute pour les questions les plus posées et leurs réponses!",
        "questions": " Pas de Questions | 1 Question | {count} Questions",
        "showQuestionListFor": "Montrer les FAQ's de",
        "title": "Questions Fréquemment Posées"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Vous trouverez ici des réponses aux questions générales ou posées par d’autres.",
            "title": "Questions fréquemment posées"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Répondez aux questions générales que vos clients pourraient avoir.",
            "title": "Créez votre première liste de FAQ"
          }
        }
      },
      "toasts": {
        "create": "Liste FAQ créée",
        "delete": "Liste FAQ supprimée",
        "update": "Liste FAQ modifiée"
      },
      "validation": {
        "needName": "Titre requis",
        "selectQuestionList": "Sélectionner au moins 1 liste FAQ"
      }
    }
  }
}